import { GameApp } from './GameApp';

if (import.meta.env.PROD) {
  for (const el of document.querySelectorAll('.dev-only')) el.remove();
}

const app = new GameApp();

// HMR / cleanup
if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    app.dispose();
  });
}
